import { Box, InputLabel, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { ChangeEvent, FC, useState } from 'react';
import { BackendFolder } from '@/types/backend';
import FolderTreeView from '@/components/navigation/folder/FolderTreeView';

type CopyApplicationDialogProps = {
  folders: BackendFolder[] | undefined;
  currentRevision?: number;
  open: boolean;
  onSelect: (folderId: number, revision?: number) => void;
  onClose: () => void;
};

const CopyApplicationDialog: FC<CopyApplicationDialogProps> = (props) => {
  const [selectedFolderId, setSelectedFolderId] = useState<number>(1);
  const [revision, setRevision] = useState<number>();

  function handleRevision(e: ChangeEvent<HTMLInputElement>) {
    const value = !Number.isNaN(e.currentTarget.valueAsNumber) ? e.currentTarget.valueAsNumber : undefined;
    setRevision(value);
  }

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Select folder to copy application to</DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <FolderTreeView
          folders={props.folders}
          foldersOnly
          onFolderClick={(folder) => setSelectedFolderId(folder.folderId)}
          onFolderDoubleClick={(folder) => props.onSelect(folder.folderId, revision)}
        />
        <Box marginTop={1} marginBottom={1}>
          <InputLabel id='enum-select-label'>Select revision to copy</InputLabel>
          <InputLabel id='enum-select-label'>Leave empty for latest revision</InputLabel>
        </Box>
        <TextField
          size='small'
          label='Revision number'
          type='number'
          value={revision}
          onChange={handleRevision}
          InputProps={{ autoComplete: 'off' }}
        />
        {props.currentRevision && (
          <InputLabel sx={{ marginTop: 1 }} id='enum-select-label'>
            Latest revision is: {props.currentRevision}
          </InputLabel>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color='primary'>
          Cancel
        </Button>
        <Button onClick={() => props.onSelect(selectedFolderId, revision)} color='primary'>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CopyApplicationDialog;
